import { LeaveApprovalStatusEnum } from '@gtpl/shared-models/common-models';
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('visitorentry')
export class VisitorEntry {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: number;

    @Column('int',{
        name:'request_id',
    })
    requestId: number;

    @Column('varchar',{
        name:'visitor_name',
        length:36
    })
    visitorName: string;

    @Column('varchar', {
        name:'visitor_card'
    })
    visitorCard: string;

    @CreateDateColumn({
        name:'check_in',
        type:'datetime'
    })
    checkIn: Date;

    @Column('datetime',{
        name:'check_out',
    })
    checkOut: Date;


    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
    
}
